import { render, staticRenderFns } from "./bookPerson.vue?vue&type=template&id=5817447f&"
import script from "./bookPerson.vue?vue&type=script&lang=js&"
export * from "./bookPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports